import React, { useState } from 'react';
import { homeAPI } from '../../../services/api';

function SubscribeForm() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setMessage('');
        setError(null);
        setIsSubmitting(true);

        try {
            // Simple email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setMessage('Please enter a valid email address.');
                setIsSubmitting(false);
                return;
            }

            // Subscribe through the API and wait for the response
            const response = await homeAPI.subscribe(email);
            
            // Check that we have a successful response
            if (response && response.success) {
                setMessage(response.message || 'Subscription successful!');
                setEmail(''); // Clear the input field
            } else {
                // Handle the case where the function returned but without success
                throw new Error(response?.message || 'Failed to subscribe, please try again.');
            }
        } catch (error) {
            setError(error.message || 'Failed to save subscription');
            setMessage('');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="subscribe-form-container">
            <form onSubmit={handleSubscribe} className="subscribe-form">
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="subscribe-input"
                    disabled={isSubmitting}
                />
                <button 
                    type="submit" 
                    className="subscribe-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
            </form>
            {message && <p className={`subscribe-message ${message.includes('successful') ? 'success' : 'error'}`}>{message}</p>}
            {error && <div className="error-message">{error}</div>}
        </div>
    );
}

export default SubscribeForm;
